import Vue from 'vue'
import App from './App.vue'
import store from './store'
import VueResource from 'vue-resource'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VueImg from 'v-img';

Vue.config.productionTip = false

Vue.use(VueResource)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(require('vue-moment'));
Vue.use(VueImg);

import './styles/custom.scss'

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')
